module.exports = __webpack_public_path__ + "img/neck_width.60bc7398.png";